"use client"
import "./partnerStyle.css"

export default function PartnerNavbar({
  title = "Partner Portal",
  userName = "",
  onProfile = () => {},
  onLogout = () => {},
}) {
  return (
    <header className="ps-navbar" role="banner">
      <div className="ps-nav-inner" aria-live="polite">
        <div className="ps-brand">
          <span className="ps-brand-pill" aria-hidden />
          <span className="ps-titlename">{title}</span>
        </div>

        <div className="ps-user">
          <span className="sr-only">Signed in as</span>
          <span className="hidden sm:inline">{userName || "Partner"}</span>
          <div className="ps-actions">
            <button
              type="button"
              className="ps-btn ps-btn-secondary"
              onClick={onProfile}
              aria-label="Open profile"
              title="Profile"
            >
              Profile
            </button>
            <button
             type="button"
             className="ps-btn ps-btn-ghost"
            onClick={() => {
            if (window.confirm("Are you sure you want to logout?")) {
           onLogout();
           }
            }}
           aria-label="Logout"
           title="Logout"
          >
         Logout
        </button>

          </div>
        </div>
      </div>
    </header>
  )
}
